import {CommonService} from '../../services/common.service';
import {AutomationsService} from '../../services/automations.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ToastMessagesService} from '../../services/toast-messages.service';
import {MatDialog} from '@angular/material/dialog';
import {NewNotificationComponent} from './dialogs/new-notification/new-notification.component';
import {MatTableDataSource} from '@angular/material/table';
import {
  SimpleConfirmActionDialogComponent
} from '../../common/simple-confirm-action-dialog/simple-confirm-action-dialog.component';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';

interface Model {
  id: number;
  name: string;
}

interface Email {
  id: number;
  email: string;
  type_description: string;
}

interface PushNotification {
  id: number;
  username: string;
  type_description: string;
}

@Component({
  selector: 'app-automations',
  styleUrls: ['./automations.component.scss'],
  templateUrl: './automations.component.html'
})
export class AutomationsComponent implements OnInit {
  selectedType: Model;
  commandTypes: any;
  types: any;
  isLoading: boolean;
  automations: any;
  public tableHeight: any;
  public tableContainerHeight: any;
  public tableContainerWidth: any;
  displayEmailColumns = ['id', 'email', 'type_description', 'actions'];
  displayNotificationColumns = ['id', 'username', 'type_description', 'actions'];
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild('paginatorAutomation', {static: true}) paginatorRefrigerator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(private commonService: CommonService,
              private automationsService: AutomationsService,
              private matDialog: MatDialog,
              private toastMessagesService: ToastMessagesService) {
    this.isLoading = true;
    this.commandTypes = [];
    this.types = [];
    this.automations = [];
    this.tableContainerHeight = window.innerHeight - 350;
    this.tableContainerWidth = window.innerWidth - 310;
    this.tableHeight = this.tableContainerHeight - 150;
  }

  public async ngOnInit(): Promise<any> {
    await this.initializeCommandTypes();
    await this.initializeTypes();
    this.isLoading = false;
  }

  async initializeCommandTypes() {
    try {
      this.commandTypes = await this.automationsService.fetchCommandTypes();
    } catch (e) {
      this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να φέρουμε τους τύπους εντολών');
    }
  }

  async initializeTypes() {
    try {
      this.types = await this.automationsService.fetchTypes();
    } catch (e) {
      this.toastMessagesService.toastErrorMessage('Δεν μπορέσαμε να φέρουμε τους τύπους των ειδοποιήσεων');
    }
  }

  async modelChanged() {
    try {
      if (+this.selectedType.id === 1) {
        this.automations = new MatTableDataSource<Email>();
        this.automations = new MatTableDataSource<Email>(await this.automationsService.fetchAutomationsByType(+this.selectedType.id) as Email[]);
      } else {
        this.automations = new MatTableDataSource<PushNotification>();
        this.automations = new MatTableDataSource<PushNotification>
        (await this.automationsService.fetchAutomationsByType(+this.selectedType.id) as PushNotification[]);
      }
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  applyFilter(filterValue: string) {
    this.automations.filter = filterValue.trim().toLowerCase();
  }

  showPartsDialog() {
    const dialog = this.matDialog.open(NewNotificationComponent, {
      width: '450',
      data: {

      }
    });

    dialog.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          if (result.type === 1) {
            await this.automationsService.insertEmailToList(result);
            await this.modelChanged();
          } else {
            await this.automationsService.insertUserToList(result);
            await this.modelChanged();
          }
          this.toastMessagesService.toastInsertSuccess();
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.error.message);
        }
      }

    });
  }

  showConfirmDeleteDialog(element: any) {
    const type = +this.selectedType.id === 1 ? 'email' : 'χρήστη';
    const confirm = this.matDialog.open(SimpleConfirmActionDialogComponent, {
      data: {
        title: `Διαγραφή ${type}`,
        message: `Είστε σίγουροι ότι θέλετε να διαγράψετε το ${type} από τη λίστα;`
      }
    });

    confirm.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          +this.selectedType.id === 1 ? await this.automationsService.removeEmailFromList(element.id) :
          await this.automationsService.removeUserFromList(element.id);
          this.toastMessagesService.toastDeleteSuccess();
          await this.modelChanged();
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }


}
